<template>
  <div class="componentRouter">
    <indexTop v-if="this.$route.name=='index'"></indexTop>
    <contact v-if="this.$route.name=='contact'"></contact>
    <introduce v-if="this.$route.name=='introduce'"></introduce>
    <consultation v-if="this.$route.name=='consultation'"></consultation>
    <about v-if="this.$route.name=='about'"></about>
    <detail v-if="this.$route.name=='detail'"></detail>
    <paymentDetail v-if="this.$route.name=='paymentDetail'"></paymentDetail>
    <div class="componentRouter_sett">
      <settlementCertificate v-if="this.$route.name=='settlementCertificate'"></settlementCertificate>
    </div>
    
  </div>
</template>

<script>
import indexTop from "../page/indexTop"; //中间件
import contact from "../page/contact"; //中间件
import introduce from "../page/introduce"; //中间件
import consultation from "../page/consultation"; //中间件
import about from "../page/about"; //中间件
import detail from "../page/detail"; //中间件
import paymentDetail from "../page/paymentDetail"; //中间件
import settlementCertificate from "../page/settlementCertificate"; //中间件
export default {
  // props: ["componentName"],
  components: {
    indexTop,
    contact,
    introduce,
    consultation,
    about,
    detail,
    paymentDetail,
    settlementCertificate
  },
  
  data() {
// console.info(this,"componentName")

    return {
    };
  },
  computed: {
    
  },
  watch: {
     
  },
  methods: {}
};
</script>
<style>
.componentRouter{
  height: 100%;
}
.componentRouter .componentRouter_sett{
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/page/indexs.vue